import Axios from "axios";

import environment from "@/environment";
import { RequestInterceptor } from "./request.interceptor";

export class GruposService {
	axios;

	constructor () {
		const interceptor = new RequestInterceptor();
		this.axios = Axios.create({ baseURL: `${environment.API}/v1` });
		this.axios.interceptors.request.use(interceptor.addAuthorizationHeader);
	}

	async listGroups (query) {
		const response = await this.axios.get("groups", { params: { query } });
		return response.data;
	}

	async addGroups (grupo) {
		const response = await this.axios.post("groups", grupo);
		return response.data;
	}

	async updateGroups (id, grupoAtulizado) {
		const response = await this.axios.put(`groups/${id}`, grupoAtulizado);
		return response.data;
	}

	async deleteGroups (id) {
		const response = await this.axios.delete(`groups/${id}`);
		return response.data;
	}
}
